import React from 'react';
import Icon from '@chakra-ui/icon';
import { IconButton, Menu as ChakraMenu, MenuButton } from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';

interface MenuProps {
  children: React.ReactNode;
  isDisabled?: boolean;
  fontSize?: string;
}
export const Menu: React.FC<MenuProps> = ({
  children,
  isDisabled = false,
  fontSize = 'xl',
}) => {
  return (
    <ChakraMenu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        p={0}
        style={{
          borderColor: 'transparent',
          background: 'none',
        }}
        _hover={{
          borderColor: 'transparent',
          background: 'none',
        }}
        icon={<Icon as={FiMoreVertical} fontSize={fontSize} />}
        variant="outline"
        isDisabled={isDisabled}
      />
      {children}
    </ChakraMenu>
  );
};
